export const onRouteUpdate = ({ location }) => {
  const path = location.pathname || '';
  const isQuiz =
    path === '/quiz' ||
    path === '/quiz/' ||
    path.endsWith('/quiz') ||
    path.endsWith('/quiz/');

  if (isQuiz) {
    document.body.classList.add('quiz-mode');
  } else {
    document.body.classList.remove('quiz-mode');
  }
};
